// Asal: Größe auf der Produktkachel wählen und direkt in den Warenkorb legen (öffnet den Impulse-Drawer).
(() => {
  document.addEventListener('click', e => {
    const size = e.target.closest('.asal-cardbuy__size');
    if (!size) return;
    const form = size.closest('[data-asal-cardbuy]');
    form.querySelectorAll('.asal-cardbuy__size').forEach(b => b.setAttribute('aria-checked', String(b === size)));
    form.querySelector('[name="id"]').value = size.dataset.id;
    const card = form.closest('.grid-product__content, .grid__item') || form.parentElement;
    const price = card.querySelector('[data-asal-cardprice]');
    const unit = card.querySelector('[data-asal-cardunit]');
    if (price) price.textContent = size.dataset.price;
    if (unit) unit.textContent = size.dataset.unit;
  });

  // Viele Varianten: Auswahlliste statt Pillen
  document.addEventListener('change', e => {
    const sel = e.target.closest('[data-asal-cardselect]');
    if (!sel) return;
    const form = sel.closest('[data-asal-cardbuy]');
    const opt = sel.selectedOptions[0];
    form.querySelector('[name="id"]').value = opt.value;
    const card = form.closest('.grid-product__content, .grid__item') || form.parentElement;
    const price = card.querySelector('[data-asal-cardprice]');
    const unit = card.querySelector('[data-asal-cardunit]');
    if (price) price.textContent = opt.dataset.price;
    if (unit) unit.textContent = opt.dataset.unit;
  });

  // Empfehlungs-Kacheln: Klick auf „In den Warenkorb“ öffnet die Größenwahl, eine Größe wählen legt sie direkt in den Warenkorb
  const closePicks = except => document.querySelectorAll('[data-asal-cardpick]:not([hidden])').forEach(p => { if (p !== except) p.hidden = true; });
  document.addEventListener('click', e => {
    const opt = e.target.closest('[data-asal-cardpick-id]');
    if (opt) {
      const form = opt.closest('[data-asal-cardbuy]');
      form.querySelector('[name="id"]').value = opt.dataset.asalCardpickId;
      const card = form.closest('.grid-product__content, .grid__item') || form.parentElement;
      const price = card.querySelector('[data-asal-cardprice]');
      const unit = card.querySelector('[data-asal-cardunit]');
      if (price) price.textContent = opt.dataset.price;
      if (unit) unit.textContent = opt.dataset.unit;
      opt.closest('[data-asal-cardpick]').hidden = true;
      form.dataset.asalPicked = '1';
      form.requestSubmit();
      return;
    }
    if (e.target.closest('[data-asal-cardpick-close]')) { closePicks(); return; }
    const form = e.target.closest('[data-asal-cardbuy]');
    closePicks(form && form.querySelector('[data-asal-cardpick]'));
  });
  document.addEventListener('keydown', e => { if (e.key === 'Escape') closePicks(); });

  document.addEventListener('submit', async e => {
    const form = e.target.closest('[data-asal-cardbuy]');
    if (!form) return;
    e.preventDefault();
    const pick = form.querySelector('[data-asal-cardpick]');
    if (pick && form.closest('.asal-recs') && form.dataset.asalPicked !== '1') {
      pick.hidden = false;
      const first = pick.querySelector('[data-asal-cardpick-id]:not([disabled])');
      if (first) first.focus({ preventScroll: true });
      return;
    }
    delete form.dataset.asalPicked;
    const btn = form.querySelector('.asal-cardbuy__add');
    const label = btn.querySelector('span');
    const text = label.textContent;
    btn.disabled = true;
    try {
      const res = await fetch('/cart/add.js', { method: 'POST', headers: { Accept: 'application/json' }, body: new FormData(form) });
      const data = await res.json();
      if (!res.ok) throw new Error(data.description || 'Nicht verfügbar');
      label.textContent = '✓ Im Warenkorb';
      btn.classList.add('is-added');
      document.dispatchEvent(new CustomEvent('ajaxProduct:added', { detail: { product: data, addToCartBtn: btn } }));
    } catch (ex) {
      label.textContent = ex.message;
    } finally {
      setTimeout(() => { label.textContent = text; btn.classList.remove('is-added'); btn.disabled = false; }, 2200);
    }
  });

  // Termin-Karte im mobilen Menü: nächster Abholtermin live aus dem Orangen Hub
  const menuNexts = [...document.querySelectorAll('[data-asal-menu-next]')];
  if (menuNexts.length) {
    const asalRun = () => (window.AsalPlace ? window.AsalPlace.load() : Promise.reject(new Error('AsalPlace fehlt'))).then(({ days = [] }) => {
      const d = days.find(x => x.bookable && x.slots.some(s => s.available)) || days[0];
      if (!d) { menuNexts.forEach(m => { m.querySelector('[data-asal-menu-next-title]').textContent = 'Abholtermine ansehen'; m.querySelector('[data-asal-menu-next-text]').textContent = 'Termine, Bestellschluss und freie Plätze'; }); return; }
      const longDate = (d => new Date(d + 'T12:00:00').toLocaleDateString('de-DE', { weekday: 'long' }) + ', ' + new Date(d + 'T12:00:00').toLocaleDateString('de-DE', { day: '2-digit', month: '2-digit', year: 'numeric' }));
      const day = longDate(d.date);
      // Handy-Menü kompakt: „Nächste Abholung · Sa. 28.11.“; Desktop-Mega-Menü wie bisher
      const shortDate = x => new Date(x + 'T12:00:00').toLocaleDateString('de-DE', { weekday: 'short', day: '2-digit', month: '2-digit' });
      const compact = m => m.classList.contains('asal-mm__promo');
      menuNexts.forEach(m => { m.querySelector('[data-asal-menu-next-title]').textContent = compact(m) ? 'Nächste Abholung' : (m.querySelector('.asal-mega__promoTxt small') ? '' : 'Nächste Abholung: ') + day; });
      let sub = 'Buchung startet bald';
      if (d.bookable && d.deadline) {
        const [dd, t] = d.deadline.split('T');
        sub = 'Bestellen bis ' + longDate(dd) + ', ' + t + ' Uhr';
      }
      const subShort = d.bookable && d.deadline ? `bestellen bis ${shortDate(d.deadline.split('T')[0])}` : 'Buchung startet bald';
      menuNexts.forEach(m => { m.querySelector('[data-asal-menu-next-text]').textContent = compact(m) ? `${shortDate(d.date)} · ${subShort}` : sub; });
    }).catch(() => {});
    asalRun();
    document.addEventListener('asal:place', asalRun);
  }
  // Mobiles Menü: zweite Ebene öffnen und zurück
  document.addEventListener('click', e => {
    const open = e.target.closest('[data-asal-mm-open]');
    const back = e.target.closest('[data-asal-mm-back]');
    if (!open && !back) return;
    const mm = (open || back).closest('[data-asal-mm]');
    mm.querySelectorAll('.asal-mm__panel').forEach(p => { p.hidden = !open || p.id !== open.dataset.asalMmOpen; });
    mm.querySelector('.asal-mm__main').hidden = !!open;
    const scroller = mm.closest('.drawer__scrollable');
    if (scroller) scroller.scrollTop = 0;
  });
})();
